/**
 * GridDollarSign
 * Render a small dollar-sign in DataGridCell
 */
export function GridDollarSign() {
    // Just an little itty bitty bit of spacing (sorry, Adam)
    return <span style={{ marginRight: "1px" }}>$</span>;
}
